export default {
  "open_platform": "LeFu Open Platform",
  "faster_cheaper": "Faster, Cheaper, Easier Development, Faster Ownership",
  "what_we_can_do": "What We Can Do",
  "custom_smart_scale": "Custom Smart Scale",
  "build_health_ecosystem": "Build your custom smart hardware, health management App, and health management platform using our smart scale as a carrier. One-stop solution to create your health management ecosystem.",
  "learn_more": "Learn More",
  "wechat_mini_program_integration": "Wechat Mini Program Integration",
  "low_cost_health_mini_program": "Low-cost development of health management mini programs. We provide various customization modes such as mini-program OEM customization, ODM deep customization, and self-development of mini-program plugins.",
  "view_docs": "View Docs",
  "app_integration": "App Integration",
  "ios_android_sdk": "Providing iOS and Android platform SDKs to help developers simplify the development process and implement Bluetooth protocol analysis and body data calculation functions.",
  "massive_food_data": "Massive Food Data",
  "easily_access_nutritional_info": "Easily access nutritional information, calories, ingredients, and more for various foods. Our service is based on authoritative food databases that cover millions of food items.",
  "why_choose_us": "Why Choose Us",
  "independent_research": "Independent Research",
  "professional_team": "We have a professional R&D team with over one hundred members. We have independently developed more than 30 practical patents, over 70 design patents, and over 20 software copyrights. The number of new patents added every year ranks among the top in the industry. After continuous efforts, we were honored as a Shenzhen high-tech enterprise in 2016. From project design and development to finalization, our strong R&D design team strictly controls every aspect.",
  "design_innovation": "Design Innovation",
  "professional_design_team": "Our company has a professional design team and maintains close cooperation with external professional design companies. We actively sponsor multiple industrial design innovation competitions. We provide each customer with an exclusive ID for design, ensuring uniqueness across all platforms after finalization and guaranteeing that each customer's product appearance is unique.",
  "comprehensive_quality_control": "Comprehensive Quality Control",
  "market_leader_quality": "As a manufacturing company, quality is our primary competitive advantage. In 2015, our company implemented ISO9001:2015 quality management system, followed by the introduction of ISO13485 medical management system in 2017. In 2018, we obtained CFDA production license. Our quality standards continue to improve. While demanding excellence from ourselves, we also establish high-standard assessment and management systems for suppliers to control quality at the source. Our quality standards are at the top level in the industry.",
  "software_customization": "Software Customization",
  "professional_stable_service": "Whether it's a mini-program or an app, we can provide professional, secure, and stable services. Our company has the largest software development team in this industry, with successful online cases numbering in the hundreds. Each position is manned by senior engineers, and the team currently has over 50 members, with rapid development.",
  "smart_manufacturing": "Smart Manufacturing",
  "logistics_automation": "LeFu's smart manufacturing production line realizes logistics conveying and automated production monitoring throughout the entire process from raw material online, processing, quality control to finished product offline. This improves our capability for quality control and flexible delivery, enabling more effective satisfaction of different customer needs.",
  "dedicated_service": "Dedicated Service",
  "pre_sales": "Pre-Sales: Help you understand the market situation of electronic scales, strengthen mutual understanding, and enable you to choose satisfactory products.",
  "in_sales": "In-Sales: Arrange product knowledge training; hold pre-production order review meetings to ensure smooth order delivery and product quality.",
  "after_sales": "After-Sales: 24/7 online support for any difficulties or questions you may have. We have a complete after-sales service process and management system.",
  "our_partners": "Our Partners",
  "login_register": "Login/Register",
  "personal_info": "Personal Information",
  "logout": "Logout",
  "language": "Language",
  "contact_email": "Contact Email",
  "product_center": "Product Center",
  "weight_scale": "Weight Scale",
  "body_fat_scale": "Body Fat Scale",
  "kitchen_scale": "Kitchen Scale",
  "2in1_nutrition_scale": "2-in-1 Nutrition Scale",
  "business_cooperation": "Business Cooperation",
  "cooperation_process": "Cooperation Process",
  "core_advantages": "Core Advantages",
  "customer_cases": "Customer Cases",
  "about_us": "About Us",
  "lefufu_intro": "Lefufu Introduction",
  "lefufu_culture": "Lefufu Culture",
  "talent_recruitment": "Talent Recruitment",
  "document_center": "Document Center",
  "homepage": "Homepage" ,
  "password_login": "Password login",
  "code_login": "Code login",
  "enter_account": "Enter account, email or phone number",
  "enter_password": "Enter password",
  "enter_email_or_phone": "Enter email or phone number",
  "get_verification_code": "Get verification code",
  "resend": "Resend",
  "enter_verification_code": "Enter verification code",
  "new_user_register": "New user? Register with SMS to automatically create an account",
  "agree_terms_conditions": "I have read and agree to the",
  "terms_privacy_policy": "Terms and Privacy Policy",
  "go_to_register": "Go to register",
  "login": "Login",
  "age_required": "Age is required",
  "enter_valid_number": "Please enter a valid number",
  "must_be_18_or_above": "Must be 18 years or older",
  "enter_username": "Enter username",
  "enter_valid_phone": "Please enter a valid phone number",
  "username_restrictions": "Username can only contain letters, numbers, and underscores, with a length of 3 to 16 characters",
  "phone_email_required": "Phone number and email cannot be empty",
  "enter_valid_phone_email": "Please enter a valid phone number or email address",
  "enter_valid_email_email": "Please enter a valid email address or email address",
  "enter_phone": "Please enter phone number",
  "enter_valid_phone_or_email": "Please enter a valid phone number or email",
  "accept_terms_privacy": "You need to accept the Terms and Privacy Policy",
  "login_success": "Login successful",
  "login_expired": "Your login has expired, please log in again",
  "account_registration": "Account Registration",
  "phone_registration": "Phone Registration",
  "account": "Account",
  "password": "Password",
  "confirm_password": "Confirm Password",
  "verification_code": "Verification code",
  "phone_number": "Phone number",
  "already_have_account": "Already have an account?",
  "direct_login": "Direct login",
  "register": "Register",
  "username_restrictions_2": "Username can only contain letters, numbers, and underscores, must include at least one letter, with a length of 3 to 16 characters",
  "password_requirements": "Password must be 6-20 characters long and include both numbers and letters",
  "enter_confirm_password": "Please enter confirm password",
  "passwords_do_not_match": "Passwords do not match",
  "enter_email": "Please enter email",
  "enter_valid_email": "Please enter a valid email",
  "basic_information": "Basic Information",
  "enter": "Enter",
  "nickname": "Nickname",
  "email_2": "Email",
  "once_filled_no_changes": "Once filled, cannot be changed. Please fill in carefully",
  "phone": "Phone",
  "registration_date": "Registration Date",
  "company_address": "Company Address",
  "position_in_company": "Position in Company",
  "select": "Select",
  "you_dont_have_appkey": "You don't have an appKey",
  "copy": "Copy",
  "view_my_appkey": "View my AppKey",
  "enter_nickname": "Please enter nickname",
  "length_between_2_20": "Length must be between 2 and 20 characters",
  "enter_registration_date": "Please enter registration date",
  "enter_company_name": "Please enter company name",
  "enter_company_address": "Please enter company address",
  "select_position": "Please select position",
  "male": "Male",
  "female": "Female",
  "secret": "Secret",
  "boss": "Boss",
  "operations": "Operations",
  "development": "Development",
  "product": "Product",
  "other": "Other",
  "copy_success": "Configuration copied successfully",
  "complete_user_company_info": "Please complete user and company information first",
  "download_my_config": "Download configuration file",
  "download": "download",
  "registration_process_document": "Registration Process Document",
  "note": "Note: If account is not provided, you can authorize our account as a developer",
  "third_party_data_service": "Third Party Data Service",
  "operating_document": "Operating Document",
  "note2": "Note: If relevant information is not provided, this feature cannot be enabled",
  "information_related": "Information Related",
  "sender_email": "Sender Email",
  "default_use": "Default Use",
  "send_password_verification_code_email": "Send Password Verification Code Email",
  "sender_email_password": "Sender Email Password",
  "customer_service_email": "Customer Service Email",
  "company_name": "Company Name",
  "language_support": "Language Support",
  "please_select": "Please Select",
  "privacy_policy": "Privacy Policy",
  "user_agreement": "User Agreement",
  "company_abbreviation": "Company Abbreviation",
  "Joyful_Commerce": "Joyful Commerce",
  "Joyful_Commerce_contact": "Joyful Commerce Contact",
  "need_to_acquire_first": "Need to Acquire First",
  "age_cannot_be_blank": "Age cannot be blank",
  "please_enter_numeric_value": "Please enter numeric value",
  "please_enter_apple_id": "Please enter Apple ID",
  "please_enter_correct_apple_id": "Please enter correct Apple ID",
  "please_enter_google_id": "Please enter Google ID",
  "please_enter_correct_google_id": "Please enter correct Google ID",
  "cannot_be_blank": "Cannot be blank",
  "language_selection_required": "Language selection required",
  "incorrect": "Incorrect",
  "format_error": "Format error",
  "Simplified_Chinese": "Simplified Chinese",
  "Chinese_Taiwan": "Chinese Taiwan",
  "Arabic": "Arabic",
  "Czech": "Czech",
  "German": "German",
  "English": "English",
  "Spanish": "Spanish",
  "French": "French",
  "Hungarian": "Hungarian",
  "Italian": "Italian",
  "Japanese": "Japanese",
  "Korean": "Korean",
  "Dutch": "Dutch",
  "Polish": "Polish",
  "Portuguese": "Portuguese",
  "Russian": "Russian",
  "Vietnamese": "Vietnamese",
  "Thai": "Thai",
  "Indonesian": "Indonesian",
  "Turkish": "Turkish",
  "Danish": "Danish",
  "avatar_image_must_be_JPG": "Avatar image must be in JPG format!",
  "avatar_image_size_limit_2MB": "Avatar image size cannot exceed 2MB!",
  "default_use_email": "Default use uniqueLife@healthscale8.com to send password verification code email",
  "developer_information": "Developer Information",
  "custom_data": "Custom data",
  "contact_info_required": "Contact information must not be empty",
  "app_key": "My AppKey",
  "my_device": "My device",
  "add_device": "Add device",
  "device_add_tip": "Each device model only needs to be added once, no need to repeat for every physical device",
  "no_device_to_download": "No device available. Please add a device before downloading the configuration file",
  "please_input": "Please enter",
  "device_name": "Bluetooth name(deviceName)",
  "advLength": "Broadcast data length(advLength)",
  "sign": "sign",
  "scan_bluetooth_device": "Scan Bluetooth device",
  "rescan_advertisements": "Rescan advertisements",
  "bluetooth_retrying": "No advertisement received yet, listening continues automatically. Please keep the scale advertising",
  "bluetooth_scanning": "Please step on the scale first to wake it up, then select it in the browser popup. Items shown as 'Unknown or unsupported device' are usually not the scale; the bottom button only grants access and does not actually pair",
  "bluetooth_waiting_adv": "Listening for advertisements (up to 30s): please step on the scale NOW to make it advertise. The advertising window is very short",
  "bluetooth_scan_success": "Bluetooth info auto-filled, please verify before submitting",
  "bluetooth_scan_cancelled": "Device selection cancelled",
  "bluetooth_scan_failed": "Bluetooth scan failed, please fill in manually or use a phone",
  "bluetooth_scan_timeout": "No advertisement received from the scale: its advertising window is very short. Please retry and step on the scale immediately after selecting the device",
  "bluetooth_adv_not_supported": "Bluetooth name has been filled in, but this browser cannot read advertisement data: newer Chrome removed the old API and the new scan API requires an experimental feature. Please open chrome://flags, enable 'Experimental Web Platform features', relaunch the browser and retry, or use a phone",
  "bluetooth_not_supported": "This computer has no Bluetooth or the browser does not support it. Please use a phone to get deviceName, sign and advLength, then fill in manually",
  "bluetooth_unavailable_tip": "No Bluetooth available, please use a phone to get the values and fill in manually",
  "bluetooth_version_low_tip": "This browser engine is older than Chrome 100, advertisement data cannot be read. Please upgrade the browser or use a phone",
  "bluetooth_adv_raw": "Advertisement manufacturer data (hex, for reference)",
  "please_fill_in_the_required_fields": "Please fill in all required fields",
  "android_access": "Android Access",
  "ios_access": "IOS Access",
  "software_service": "Software service",
  "enter_phone_or_email": "Please enter your phone number or email address",
  "device_setting": "Device Configuration",
  "device_setting_doc": "Registration & Configuration Best Practices",
  "wait_for": "Coming soon",
  "compare_data": "Compare data",
  "my_ticket": "My Ticket",
  "workbench": "Workbench",
  "workbench_oem": "OEM Workbench",
  "new_ticket": "New Ticket",
  "ticket_number": "Ticket Number",
  "problem_description": "Problem Description",
  "category": "Category",
  "status": "Status",
  "submission_time": "Submission Time",
  "operation": "Operation",
  "view": "View",
  "delete": "Delete",
  "prompt": "Prompt",
  "confirm_deletion": "Confirm Deletion of Ticket",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "title": "Title",
  "upload_attachment": "Upload Attachment",
  "drag_files_here": "Drag files here, or",
  "click_to_upload": "Click to Upload",
  "select_category": "Select Category",
  "send_email": "Send Email",
  "send": "Send",
  "do_not_send": "Do Not Send",
  "email": "Email",
  "access": "Access",
  "mini_program_access": "Mini Program Access",
  "cloud_computing_library": "Cloud Computing Library",
  "device_configuration": "Device Configuration",
  "awaiting_platform_feedback": "Awaiting Platform Feedback",
  "awaiting_your_feedback": "Awaiting Your Feedback",
  "resolved": "Resolved",
  "title_cannot_be_empty": "Title cannot be empty",
  "problem_description_cannot_be_empty": "Problem description cannot be empty",
  "category_cannot_be_empty": "Category cannot be empty",
  "this_is_a_problem_description": "This is a problem description",
  "technical_issue": "Technical Issue",
  "pending": "Pending",
  "reset_to_first_page": "Reset to First Page",
  "retrieve_data_again": "Retrieve Data Again",
  "upload_successful": "Upload Successful",
  "upload_failed": "Upload Failed",
  "confirm_close": "Confirm Close?",
  "reply": "Reply",
  "allow_wrapping": "Allow Wrapping",
  "wrap_after_exceeding_visible_area": "Wrap after exceeding visible area",
  "communication_records": "Communication Records",
  "attachment": "Attachment",
  "drag_attachment_here": "Drag attachment here, or",
  "submit": "Submit",
  "content_cannot_be_empty": "Content cannot be empty",
  "file_size_exceeds_limit": "File size should not exceed 10MB!",
  "file_already_exists": "File already exists, duplicate uploads are not allowed!",
  "owner_server": "Set Up a WiFi Scale Server","sou_suo":  "search",
  "zhong_zhi":  "Reset",
  "request_url":"Request Url",
  "request_data":"Request (device ➜ server)",
  "response_data":"Response (Server ➜ Device)",
  "timestamp":"Timestamp",
  "device_configuration_document": "Equipment Network Configuration Practice Documentation",
  "document_address": "Document address:",
  "ri_zhi_cha_kan": "Log View",
  "cao_zuo_jiao_cheng": "Operation Tutorial",
  "qing_shu_ru_mac": "Please enter the Mac address",
  "dian_ji_da_kai": "Click to open the document",
  "flutter_integration": "Flutter Integration",
  "harmony_integration": "Harmony Integration",
  "copy_wechat_config": "Copy WeChat Mini Program configuration",
  "holtek_apply_title": "Mobile Computing Library Application",
  "holtek_pkg_placeholder": "Enter package name, e.g. com.lefu.uh001",
  "holtek_add_package": "Add Package",
  "holtek_section_list": "Package Application List",
  "holtek_col_package": "Package Name",
  "holtek_col_apply_time": "Applied At",
  "holtek_col_status": "Status",
  "holtek_col_secret4": "AC Four-Electrode Algorithm",
  "holtek_col_secret8": "AC Eight-Electrode Algorithm",
  "holtek_status_pending": "Pending",
  "holtek_status_approved": "Approved",
  "holtek_status_renewing": "Renewing",
  "holtek_submit_success": "Application submitted, please wait for approval",
  "holtek_pkg_empty": "Please enter at least one package name",
  "holtek_pkg_invalid": "Invalid package name, only letters, digits, underscore and hyphen separated by dots are allowed",
  "holtek_business_manager": "Unique Scale Business Manager",
  "holtek_business_manager_placeholder": "Enter the name or contact of the Lefu business manager",
  "holtek_col_action": "Action",
  "holtek_expire_prefix": "Expires: ",
  "holtek_renew": "Renew",
  "holtek_renew_confirm": "Current authorization expires on {expireDate} ({remain}). Renewing re-applies with this package name; once re-issued, it is valid for 5 years from the issue date. Continue?",
  "holtek_remain_days": "{n} days left",
  "holtek_remain_today": "expires today",
  "holtek_remain_expired": "expired {n} days ago",
  "holtek_remain_unknown": "expiry unknown",
  "enter_business_manager": "Please enter the Unique Scale business manager name or contact",
  "business_manager_required_msg": "Please fill in the Unique Scale business manager name or contact in Basic Information before submitting the application",
  "compute_library_apply_title": "Cloud Computing Library Application",
  "compute_library_apply_tip": "Please select the algorithms to apply for according to your scale model. After submission, wait for approval before calling the corresponding algorithm APIs",
  "compute_library_doc": "API Documentation",
  "compute_library_business_manager": "Unique Scale Business Manager Name or Contact",
  "compute_library_business_manager_placeholder": "Please enter Unique Scale business manager name or contact",
  "compute_library_select_empty": "Please select at least one algorithm",
  "compute_library_not_registered": "Not Available",

  // ===== Homepage module doc dropdown titles =====
  "mini_plugin_guide": "Mini Program Plugin - Preparation & Integration Guide",
  "mini_plugin_faq": "Mini Program Plugin - FAQ",
  "mini_plugin_device_access": "Mini Program Plugin - Device Access",
  "mini_plugin_release_notes": "Mini Program Plugin_ReleaseNotes",
  "android_sdk_guide": "Android SDK - Preparation & Integration Guide",
  "android_sdk_faq": "Android SDK - FAQ",
  "android_sdk_device_access": "Android SDK - Device Access",
  "android_sdk_release_notes": "Android_PPBTKitDemo_ReleaseNotes",
  "ios_sdk_guide": "iOS SDK - Preparation & Integration Guide",
  "ios_sdk_faq": "iOS SDK - FAQ",
  "ios_sdk_device_access": "iOS SDK - Device Access",
  "ios_sdk_release_notes": "iOS_SDK_ReleaseNotes",
  "cloud_library_guide": "Cloud Computing Library - Preparation & Integration Guide",
  "cloud_library_faq": "Cloud Computing Library - FAQ",
  "cloud_library_api_reference": "Cloud Computing Library - API Reference",
  "cloud_library_release_notes": "Cloud Computing Library_ReleaseNotes",
  "open_platform_faq": "Open Platform FAQ",
  "open_platform_best_practice": "Open Platform Registration & Configuration Best Practices",
  "wifi_server_setup": "WiFi/4G Scale Server Setup",
  "wifi_server_release_notes": "WiFi/4G Scale Server API ReleaseNotes",
  "wifi_server_faq": "WiFi/4G Scale Server API FAQ",
  "wifi_server_best_practice": "WiFi/4G Scale Server API Best Practices",
  "flutter_sdk_guide": "Flutter SDK - Preparation & Integration Guide",
  "flutter_sdk_faq": "Flutter SDK - FAQ",
  "flutter_sdk_device_access": "Flutter SDK - Device Access",
  "flutter_sdk_release_notes": "Flutter SDK Release Notes",
  "harmony_sdk_guide": "HarmonyOS SDK - Preparation & Integration Guide",
  "harmony_sdk_faq": "HarmonyOS SDK - FAQ",
  "harmony_sdk_device_access": "HarmonyOS SDK - Device Access",
  "harmony_sdk_release_notes": "HarmonyOS_SDK_ReleaseNotes",

  // ===== Workbench (auto-generated) =====
  "wb_001": "OEM Workbench",
  "wb_002": "Lefu Open Platform /",
  "wb_003": "Previous",
  "wb_004": "Save Draft",
  "wb_005": "Submit Data",
  "wb_006": "Next",
  "wb_007": "Progress: ",
  "wb_008": "Build Workflow",
  "wb_009": "Create App",
  "wb_010": "Create a new app on the IoT developer platform and fill in the basic information.",
  "wb_011": "Basic Information",
  "wb_012": "Required",
  "wb_013": "App Name",
  "wb_014": "Enter app name",
  "wb_015": "Suggested: ≤ 6 Chinese characters, ≤ 12 characters for English",
  "wb_016": "Channel Identifier / Scheme",
  "wb_017": "Auto-generate",
  "wb_018": "Identifier used to launch the app (",
  "wb_019": ") for Deep Link / push landing page navigation",
  "wb_020": "Android Package Name",
  "wb_021": "Format: com.company.product",
  "wb_022": "iOS Package Name",
  "wb_023": "Keep both platforms consistent",
  "wb_024": "Version Type",
  "wb_025": "Region",
  "wb_026": "All format checks passed",
  "wb_027": "App name, scheme, package names, version type and region all meet the requirements.",
  "wb_028": "Submitted for review in this session: version type, package names and region ",
  "wb_029": "are locked and cannot be modified",
  "wb_030": "(immutable once the app is created). To change them, create a new app.",
  "wb_031": "Once the app is created, version type, package names and region cannot be changed. Please confirm carefully before submitting.",
  "wb_032": "UI Configuration",
  "wb_033": "Customize the app's visual appearance, including icon, theme, template, splash screens and page components.",
  "wb_034": "2-A App Icon",
  "wb_035": "App Icon",
  "wb_036": "Built-in default · icon_1024.png",
  "wb_037": "Download the current icon; the file name and size are the upload requirements",
  "wb_038": "Download",
  "wb_039": "2-B Splash Screens",
  "wb_040": "Packaging contract requirements",
  "wb_041": "4 types",
  "wb_042": "Splash resources (background / logo / bottom / device frame) × 2 scales =",
  "wb_043": "8 images",
  "wb_044": "; missing \"splash background\" causes a black launch screen. Click \"Download\" on each card to get the reference image; ",
  "wb_045": "the file name and image size are the upload requirements",
  "wb_046": "Download reference image: file name and size are the upload requirements",
  "wb_047": "2-C Template & Theme",
  "wb_048": "The template decides the preview layout and light/dark mode; theme color A syncs in real time to the preview's primary color, gradients and charts, and is written to ",
  "wb_049": " ",
  "wb_050": ". Theme color B is not available yet (not in the packaging contract); the preview secondary color uses the built-in default.",
  "wb_051": "Theme Color A",
  "wb_052": "Brand Name",
  "wb_053": "(optional)",
  "wb_054": "Brand Logo",
  "wb_055": "Download the uploaded logo to verify its size before re-uploading",
  "wb_056": "2-D Page Backgrounds",
  "wb_057": "Each of the 5 pages needs @2x / @3x images (10 in total), named in the ZIP as ",
  "wb_058": "Name@2x.png",
  "wb_059": ". Click \"Download\" on each scale to get the reference image; ",
  "wb_060": "Download the reference image for this scale: file name and size are the upload requirements",
  "wb_061": "2-E Tab Bar Components",
  "wb_062": "Drag the handle on the left to reorder — the order is the app's bottom navigation order and syncs to the preview and submitted data in real time; you can also use ↑ / ↓ keys when the handle is focused.",
  "wb_063": "Reorder \"",
  "wb_064": "\"",
  "wb_065": "2-F In-page Components",
  "wb_066": "The source document only provides 5 page names without in-page component lists, so they are currently simulated with ",
  "wb_067": "placeholders",
  "wb_068": "; each page independently supports show / hide and drag sorting, with interactions identical to 2-E.",
  "wb_069": "Placeholder",
  "wb_070": "Feature Configuration",
  "wb_071": "Device support, extended features and advanced feature configuration for the app.",
  "wb_072": "3-A Extended Features",
  "wb_073": "Feedback Email",
  "wb_074": "About Page",
  "wb_075": "Text at the bottom of the in-app About page, within 200 characters",
  "wb_076": "Privacy Policy URL",
  "wb_077": "Terms of Service URL",
  "wb_078": "3-B Device Configuration",
  "wb_079": "Syncs to the \"Device\" preview page",
  "wb_080": "Device config file",
  "wb_081": "Upload config file",
  "wb_082": "3-C Computing Library Secret (oem_config.json → calculate)",
  "wb_083": "Application Status",
  "wb_084": "Valid Until",
  "wb_085": "Fill in after receiving it via email from the platform",
  "wb_086": "The computing library secret is used for body metric calculation (required for packaging, ",
  "wb_087": ") currently ",
  "wb_088": "apply to the platform by email",
  "wb_089": "and ",
  "wb_090": "with an expiry date",
  "wb_091": " — once expired, body metric calculation in the final app stops working. Renew before the expiry date.",
  "wb_092": "3-D Supported Device Models",
  "wb_093": "Configured models (custom devices configured in the backend)",
  "wb_094": "Click to remove ",
  "wb_095": "No device models configured yet",
  "wb_096": "Device model, e.g. Miao Scale S1",
  "wb_097": "Add",
  "wb_098": "3-E Module Trimming",
  "wb_099": "Unchecked = removed by the packager",
  "wb_100": "Checked = kept in the package; unchecked modules are removed from the project by the packager at build time (e.g. Umeng removed for overseas builds, Firebase for mainland builds).",
  "wb_101": "3-F Advanced Features",
  "wb_102": "Units & Language",
  "wb_103": "Configure the unit systems and language options supported by the app.",
  "wb_104": "4-A Unit Options",
  "wb_105": "Default weight unit · defaultUnit",
  "wb_106": "Default length unit · defaultLength",
  "wb_107": "Supported weight units · unitList",
  "wb_108": "Supported length units · lengthList",
  "wb_109": "4-B Language Configuration",
  "wb_110": "Default language · defaultLanguage",
  "wb_111": "Supported languages · languageList",
  "wb_112": "Select All",
  "wb_113": "Clear",
  "wb_114": "The language list corresponds to ",
  "wb_115": "(",
  "wb_116": " language codes in total). Simplified Chinese and English are enabled by default; checking a language adds it to the app. Use \"Select All / Clear\" at the top right to toggle in batch.",
  "wb_117": "Build Management",
  "wb_118": "Choose the build purpose to generate a test build or a store release build.",
  "wb_119": "Choose build type",
  "wb_120": "Target Channels",
  "wb_121": "Multi-select · determines artifact format",
  "wb_122": "The artifact format depends on the channel: mainland → APK; Google Play → AAB Bundle. A wrong channel voids the whole build.",
  "wb_123": "Simulate a failure",
  "wb_124": "The trial build is valid for 30 days. Purchase the OEM service for a release build.",
  "wb_125": "Failed Stage",
  "wb_126": "Error Code",
  "wb_127": "Failure Reason",
  "wb_128": "Suggested Fix",
  "wb_129": "Retry",
  "wb_130": "Contact Support",
  "wb_131": "Trial & Release",
  "wb_132": "Learn about test build validity and the release purchase process.",
  "wb_133": "Item",
  "wb_134": "Trial (Test)",
  "wb_135": "Release (after purchase)",
  "wb_136": "Purchase Release",
  "wb_137": "Contact Us",
  "wb_138": "Store Listing Configuration",
  "wb_139": "Agreements, certificates and third-party service configurations required before store release.",
  "wb_140": "7-A Terms of Service & Privacy Policy",
  "wb_141": "Once filled in, entries appear immediately in the \"Me\" page of the preview. Overseas release requires both English versions of the agreement and privacy policy.",
  "wb_142": "7-B iOS Certificates",
  "wb_143": "iOS certificate password · iosCerPwd",
  "wb_144": "Password set when exporting the .p12",
  "wb_145": "Required field in oem_config.json, used for signing, masked after submission",
  "wb_146": "Apple Developer Account",
  "wb_147": "7-C Android Certificates",
  "wb_148": "Android keystore file",
  "wb_149": "Android keystore file",
  "wb_150": "Keystore password · keyStorePwd",
  "wb_151": "Password of the keystore file (.jks) itself",
  "wb_152": "Key Alias",
  "wb_153": "Key password · keyAliasPwd",
  "wb_154": " — the password of the private key for the alias ",
  "wb_155": "and the Keystore password are two separate passwords",
  "wb_156": ", easily confused",
  "wb_157": "GIDClientID (Google sign-in client ID)",
  "wb_158": "Contract field in oem_config.json; required for Google sign-in. Fill in after applying to the platform.",
  "wb_159": "7-E Store Listing Information",
  "wb_160": "Company Name",
  "wb_161": "Contact Email",
  "wb_162": "Contact Person",
  "wb_163": "Contact Phone",
  "wb_164": "App Type (store category)",
  "wb_165": "Copyright Name",
  "wb_166": "Company Introduction",
  "wb_167": "Support Website",
  "wb_168": "Google Play Account",
  "wb_169": "Google Play Console account",
  "wb_170": "App Store Account",
  "wb_171": "App Store Connect account",
  "wb_172": "Search Keywords",
  "wb_173": "+ Add",
  "wb_174": "Keywords for store search optimization",
  "wb_175": "Type a keyword and click \"+ Add\" or press Enter",
  "wb_176": "Available Countries / Regions",
  "wb_177": "Countries / regions where the app can be listed",
  "wb_178": "e.g. Mainland China, Singapore",
  "wb_179": "App Description",
  "wb_180": "The build channel (mainland / Google Play) is selected in step 5 \"Target Channels\". iOS review is strict: ensure bilingual legal texts, certificate materials and listing info are complete and accurate. Common rejection reasons include a missing privacy policy and no test account provided.",
  "wb_181": "Tools",
  "wb_182": "Enhanced configurations and operational tools after release.",
  "wb_183": "QR Code Generation",
  "wb_184": "Bind store links and generate permanent QR codes for package printing.",
  "wb_185": " QR Code",
  "wb_186": "Clear",
  "wb_187": "Pgyer · Beta Distribution",
  "wb_188": "Upload installers to Pgyer",
  "wb_189": "Test builds can be distributed to beta users via Pgyer without store review.",
  "wb_190": "Copy Distribution Link",
  "wb_191": "Pgyer distribution short link copied (simulated)",
  "wb_192": "Workflow Completed",
  "wb_193": "Congratulations!",
  "wb_194": "You have completed all configuration steps. Use \"Build Management\" to create a release build and submit it for store review.",
  "wb_195": "Data & Submission",
  "wb_196": "Backend APIs are not connected yet; a local mock data layer provides the data source and submission process. Submissions do not send real network requests.",
  "wb_197": "9-A Data Source & Draft",
  "wb_198": "Data Source",
  "wb_199": "Draft Saved At",
  "wb_200": "Auto Save",
  "wb_201": "Field Completion",
  "wb_202": "Refetch (simulated server)",
  "wb_203": "Save Draft Now",
  "wb_204": "Reset to Sample Data",
  "wb_205": "9-B Submission Field List",
  "wb_206": "Required only",
  "wb_207": "Unfilled only",
  "wb_208": "Affects preview only",
  "wb_209": "Step",
  "wb_210": "Field",
  "wb_211": "Current Value",
  "wb_212": "Required",
  "wb_213": "Affects Preview",
  "wb_214": "No fields under the current filter",
  "wb_215": "9-C Submit for Review",
  "wb_216": "The button becomes available once required fields are completed",
  "wb_217": "Submission numbers and records are stored in browser localStorage",
  "wb_218": "Submission successful. No. ",
  "wb_219": "9-D Submission Records",
  "wb_220": "No.",
  "wb_221": "Type",
  "wb_222": "App",
  "wb_223": "Time",
  "wb_224": "Status",
  "wb_225": "No records yet. Records are created after \"Start Build\" or \"Submit for Review\"",
  "wb_226": "Clear Records",
  "wb_227": "9-E Resource Package Preview (packager input)",
  "wb_228": "The only interface from \"Web platform → packager\" is the ZIP package: root directory with ",
  "wb_229": "1 file",
  "wb_230": "(containing ",
  "wb_231": " five sub-configs) + 3 certificates, ",
  "wb_232": "and ",
  "wb_233": " for images. The real ZIP is packaged by the backend; this previews the packager's input.",
  "wb_234": "Image Resources (oem_config.json → ios / android)",
  "wb_235": "A confirmation dialog appears first; upload starts after confirmation: app icon, 8 splash images (background / logo / bottom / device frame × @2x @3x), and login / home-light / home-dark backgrounds, ",
  "wb_236": "uploaded only once",
  "wb_237": "; both platforms' fields are written with the same link; ",
  "wb_238": "slots without uploaded replacements",
  "wb_239": "(currently showing built-in defaults) are also written with the default image URL, ensuring ",
  "wb_240": "all node fields are complete.",
  "wb_241": "9-F Submission Payload JSON",
  "wb_242": "Live Preview",
  "wb_243": "Launch Screen",
  "wb_244": "Login Page",
  "wb_245": "Light",
  "wb_246": "Dark",
  "wb_247": "Preview zoom (Ctrl / ⌘ + scroll wheel in the preview area also works)",
  "wb_248": "Zoom out preview",
  "wb_249": "Click to reset to 100%",
  "wb_250": "Zoom in preview",
  "wb_251": "(default image)",
  "wb_252": "Enter phone number",
  "wb_253": "Enter verification code",
  "wb_254": "Sign In",
  "wb_255": "Terms of Service",
  "wb_256": "Privacy Policy",
  "wb_257": "In-page Components",
  "wb_258": "Almost there — after filling in About / Privacy Policy / Terms of Service / Feedback Email in \"3-A Extended Features\", the entries will appear here automatically.",
  "wb_259": "Config File",
  "wb_260": "AppKey comes from \"3-B Device Configuration\"",
  "wb_261": "No pages enabled",
  "wb_262": "Turn on the switches in \"2-E Tab Bar Components\" to restore the preview",
  "wb_263": "Current Step",
  "wb_264": "Page Template",
  "wb_265": "Theme Colors",
  "wb_266": "Enabled Pages",
  "wb_267": "Backgrounds / Splash",
  "wb_268": "Linked Fields",
  "wb_269": "Sync Log",
  "wb_270": "Any linked item changed in \"UI Configuration\" or \"Feature Configuration\" is logged here for each sync.",
  "wb_271": "Loading workbench data from the local mock service…",
  "wb_272": "Page background applied: ",
  "wb_273": "(",
  "wb_274": ")",
  "wb_275": ", ",
  "wb_276": ". ",
  "wb_277": ": ",
  "wb_278": ", ",
  "wb_279": "\"",
  "wb_280": "\"",
  "wb_281": "—",
  "wb_282": "Format check failed: ",
  "wb_283": " errors",
  "wb_284": " suggestions",
  "wb_285": "Format check passed, ",
  "wb_286": " complete",
  "wb_287": "Placeholder simulation ",
  "wb_288": "Masked in the submission payload as ",
  "wb_289": "Store targets: ",
  "wb_290": "Basic info & format validation",
  "wb_291": "Visual appearance customization",
  "wb_292": "Devices & extended features",
  "wb_293": "Languages & units",
  "wb_294": "Test & store builds",
  "wb_295": "Version management",
  "wb_296": "Agreements, certificates & info",
  "wb_297": "QR codes & operations",
  "wb_298": "Mock data & submission process",
  "wb_299": "Resource list",
  "wb_300": "For testing",
  "wb_301": "Generate test QR codes for both platforms; scan to install and try",
  "wb_302": "Only requires basic configuration (steps 1-3)",
  "wb_303": "Store Release",
  "wb_304": "Generate installers submittable to app stores",
  "wb_305": "Requires all store listing configurations",
  "wb_306": "Android Test Build",
  "wb_307": "iOS Test Build",
  "wb_308": "Validity",
  "wb_309": "30 days by default",
  "wb_310": "Permanent",
  "wb_311": "Store release",
  "wb_312": "Not for store release",
  "wb_313": "Submittable to major app stores",
  "wb_314": "How to get",
  "wb_315": "Scan to install after build",
  "wb_316": "Build after purchasing the OEM service",
  "wb_317": "Extra capabilities",
  "wb_318": "Modify app name, version history, update templates, data analytics",
  "wb_319": "Payment",
  "wb_320": "Online payment / offline payment binding",
  "wb_321": "Terms of Service (Chinese)",
  "wb_322": "Link for \"Me → Terms of Service\", required for store release",
  "wb_323": "Privacy Policy (Chinese)",
  "wb_324": "Link for \"Me → Privacy Policy\", required for store release",
  "wb_325": "Terms of Service (English)",
  "wb_326": "Terms of Service, required for overseas release",
  "wb_327": "Privacy Policy (English)",
  "wb_328": "Privacy Policy, required for overseas release",
  "wb_329": "Bind App Store link",
  "wb_330": "Bind Google Play link",
  "wb_331": "Please select a version type",
  "wb_332": "Please select a region",
  "wb_333": "Local draft (localStorage simulated server)",
  "wb_334": "Built-in sample data",
  "wb_335": "Fetching draft…",
  "wb_336": "Draft auto-saved ",
  "wb_337": "Draft synced",
  "wb_338": "Sample data",
  "wb_339": "Data source: ",
  "wb_340": "; last saved: ",
  "wb_341": "(empty)",
  "wb_342": "Background",
  "wb_343": "Bottom",
  "wb_344": "Device frame",
  "wb_345": " · Default",
  "wb_346": "Default image",
  "wb_347": "Pending upload",
  "wb_348": "Not configured; using theme gradient",
  "wb_349": "Built-in default · ",
  "wb_350": "Configured · ",
  "wb_351": " · Default",
  "wb_352": "BG · Home header",
  "wb_353": "BG · Profile",
  "wb_354": "Login background",
  "wb_355": "Unnamed page",
  "wb_356": ".p12 certificate file",
  "wb_357": "Not uploaded",
  "wb_358": ".p8 key (optional)",
  "wb_359": "Required in some store scenarios",
  "wb_360": "Provisioning profile linked to the App ID",
  "wb_361": "Not applied",
  "wb_362": "(no expiry set)",
  "wb_363": "Expired ",
  "wb_364": " days ago · metric calculation disabled",
  "wb_365": "Only ",
  "wb_366": " days left, please renew soon",
  "wb_367": "Remaining: ",
  "wb_368": " days",
  "wb_369": " etc. ",
  "wb_370": "distributed",
  "wb_371": " items",
  "wb_372": "Not set",
  "wb_373": "About Us",
  "wb_374": "Configured",
  "wb_375": "Feedback",
  "wb_376": "Default language",
  "wb_377": "Unnamed app",
  "wb_378": "No brand set",
  "wb_379": "Good morning",
  "wb_380": "Dark",
  "wb_381": "Light",
  "wb_382": "No components to preview on this page. Check \"2-F In-page Components\".",
  "wb_383": "On this page, ",
  "wb_384": " components are all hidden and no longer shown in the preview.",
  "wb_385": "Smart",
  "wb_386": "Body Fat Scale",
  "wb_387": "Not configured",
  "wb_388": "Using default configuration",
  "wb_389": " images",
  "wb_390": "Channel identifier generated: ",
  "wb_391": "Configuration restored from local draft",
  "wb_392": "Built-in sample data loaded",
  "wb_393": "Reset to built-in sample data",
  "wb_394": "Draft saved (localStorage simulated server)",
  "wb_395": "Template switched: ",
  "wb_396": " (preview synced)",
  "wb_397": "Enabled \"",
  "wb_398": "Hidden \"",
  "wb_399": "\" tab bar component",
  "wb_400": "Switched to \"",
  "wb_401": "\" component list",
  "wb_402": "Shown \"",
  "wb_403": "\" moved to No. ",
  "wb_404": "",
  "wb_405": "\" ",
  "wb_406": "moved up",
  "wb_407": "moved down",
  "wb_408": "Enabled \"",
  "wb_409": "Disabled \"",
  "wb_410": "\" data sync",
  "wb_411": "All 30 languages enabled",
  "wb_412": "Language list cleared",
  "wb_413": "No images available for download. Upload first or try again later.",
  "wb_414": "Download started: ",
  "wb_415": " (file name and size are the upload requirements)",
  "wb_416": "Page background",
  "wb_417": "Uploaded: ",
  "wb_418": " (click to replace)",
  "wb_419": "Showing built-in default (click to upload @",
  "wb_420": "x to replace)",
  "wb_421": "Click to upload @",
  "wb_422": " · ",
  "wb_423": "Selected ",
  "wb_424": "file",
  "wb_425": "Installer uploaded to Pgyer (simulated): ",
  "wb_426": "No images to upload yet. Upload the app icon / splash / page backgrounds in step 2 first.",
  "wb_427": "Will upload ",
  "wb_428": " images, writing ",
  "wb_429": " fields (",
  "wb_430": "The app icon shared by iOS and Android is uploaded once and written to both platforms; slots without uploads are written with built-in default image URLs. Continue?",
  "wb_431": "Batch Upload Images",
  "wb_432": "Upload",
  "wb_433": "Cancel",
  "wb_434": "Upload cancelled",
  "wb_435": "Preparing 0 / ",
  "wb_436": "Uploading ",
  "wb_437": "[oem image] Local file not found: ",
  "wb_438": "[oem image] Upload failed: ",
  "wb_439": "No image URL in the upload response",
  "wb_440": " images, ",
  "wb_441": " failed (see console for details)",
  "wb_442": " images uploaded; links written to oem_config.json",
  "wb_443": "Release build",
  "wb_444": "Test build",
  "wb_445": " still missing ",
  "wb_446": " required items (",
  "wb_447": "), complete them before building.",
  "wb_448": "Android Release Build",
  "wb_449": "iOS Release Build",
  "wb_450": "Build",
  "wb_451": "Build failed",
  "wb_452": "Build failed: ",
  "wb_453": "Build succeeded",
  "wb_454": "Build succeeded (",
  "wb_455": "), scan the QR code to install",
  "wb_456": "Keep at least one build channel",
  "wb_457": "Channel removed: ",
  "wb_458": "Channel added: ",
  "wb_459": ", artifact ",
  "wb_460": "There are still ",
  "wb_461": " required fields to complete",
  "wb_462": "After submission, \"Version Type / Package Names / Region\" will be locked and cannot be changed.\n",
  "wb_463": "Version type: ",
  "wb_464": "Release",
  "wb_465": "Trial",
  "wb_466": ", Android package: ",
  "wb_467": ", Region: ",
  "wb_468": "Mainland China",
  "wb_469": "Overseas",
  "wb_470": "\nConfirm submission?",
  "wb_471": "Submit for Review",
  "wb_472": "Submitted",
  "wb_473": "Submission successful: ",
  "wb_474": " (version type / package names / region locked)",
  "wb_475": "Local submission records cleared",
  "wb_476": "Release purchase flow started",
  "wb_477": "You are being transferred to a business advisor; please expect a call",
  "wb_478": "QR code downloaded: ",
  "wb_479": "Direct download not supported in this environment; the QR code opened in a new window",
  "wb_480": "Pgyer installer",
  "wb_481": "Model \"",
  "wb_482": "\" already exists",
  "wb_483": "Device model added: ",
  "wb_484": "Device model removed: ",
  "wb_485": "Building…",
  "wb_486": "Start Build",
  "wb_487": "Replace",
  "wb_488": "Upload",
  "wb_489": "Replace",
  "wb_490": "Download QR code",
  "wb_491": "Bind a link first",
  "wb_492": "Submitting…",
  "wb_493": "Collapse",
  "wb_494": "Expand",
  "wb_495": "Connected",
  "wb_496": "Not connected",
  "wb_497": "Optional",
  "wb_498": "Not saved",
  "wb_499": "Pending",
  "wb_500": "Saved ",
  "wb_501": "For preview",
  "wb_502": "No app icon uploaded yet",
  "wb_503": "Currently showing the built-in default icon; 1024 x 1024 px PNG without transparent padding recommended",
  "wb_504": "Upload logo",
  "wb_505": "Ready (prerequisite for release)",
  "wb_506": "Not confirmed — an Apple Developer account is required before release",
  "wb_507": "No .jks / .keystore uploaded",
  "wb_508": "Replace APK / IPA",
  "wb_509": "Upload APK / IPA",
  "wb_510": "Compile resources for both platforms",
  "wb_511": "Sign and generate QR code",
  "wb_512": "Error",
  "wb_513": "Suggestion",
  "wb_514": "Uploading…",
  "wb_515": "All ",
  "wb_516": " required fields completed — ready to submit. The submission process is locally simulated: validate → package → upload → submit.",
  "wb_517": " required fields incomplete: ",
  "wb_518": " records",
  "wb_519": " resources · ",
  "wb_520": " missing",
  "wb_521": " slots × 2 platforms = ",
  "wb_522": " fields · ",
  "wb_523": "replaced ",
  "wb_524": " · ready to upload ",
  "wb_525": "",
  "wb_526": " · Sensitive fields (AppSecret / Keystore password) are masked",
  "wb_527": "Splash ",
  "wb_528": "· background from @",
  "wb_529": "x",
  "wb_530": " shown",
  "wb_531": "Default language: ",
  "wb_532": " · supports ",
  "wb_533": " languages",
  "wb_534": " enabled",
  "wb_535": "Go to fix (step ",
  "wb_536": ")",
  "wb_537": " Build failed (No. ",
  "wb_538": "): check the hints below or contact platform support.",
  "wb_539": "Build succeeded! Build No. ",
  "wb_540": "; scan the QR code to install",
  "wb_541": "",
  "wb_542": " complete · ",
  "wb_543": "Package file names: ",
  "wb_544": "@2x.png · ",
  "wb_545": "Placeholder ",
  "wb_546": "",
  "wb_547": "… (local simulated build)",
  "wb_548": "Uploaded",
  "wb_549": "%)",
  "wb_550": " fields",
  "wb_551": ", app ",
  "wb_552": "), simulated cost ",
  "wb_553": " ms, submitted at ",
  "wb_554": " fields · replaced ",
  "wb_555": " · appId ",
  "wb_556": "…",
  "wb_557": "). ",
  "wb_558": " required items; go to step ",
  "wb_559": "A confirmation dialog appears first; upload starts after confirmation: app icon, 8 splash images (background / logo / bottom / device frame × @2x @3x), login / home-light / home-dark backgrounds @2x @3x, and profile light & dark @2x — 17 slots in total. The app icon shared by ",
  "wb_560": "iOS and Android is uploaded only once ; both platforms' fields are written with the same link; ",
  "wb_561": " · Pending upload",


  // ===== workbenchMock 数据层文案（tl() 查表） =====
  "wbm_001": "(generated from the form)",
  "wbm_002": "Android package name",
  "wbm_003": "Android package name",
  "wbm_004": "Android test build",
  "wbm_005": "Android signing files pending upload",
  "wbm_006": "Android keystore file",
  "wbm_007": "App main entry with the health overview",
  "wbm_008": "App Store account",
  "wbm_009": "Copyright name",
  "wbm_010": "GIDClientID (Google sign-in)",
  "wbm_011": "Google Play version",
  "wbm_012": "Google Play account",
  "wbm_013": "Key alias",
  "wbm_014": "Key password keyAliasPwd",
  "wbm_015": "Keystore password keyStorePwd",
  "wbm_016": "Miao Health - your smart health management assistant, recording every step of your health data.",
  "wbm_017": "Miao Health is a smart app focused on health management, helping users record and analyze health data.",
  "wbm_018": "Miao Technology focuses on smart health hardware and software services, providing customized apps for body-fat scales, wristbands and other devices.",
  "wbm_019": "The secret has been issued. Fill it in below and note the expiry date",
  "wbm_020": "Tab bar components",
  "wbm_021": "iOS .p12 certificate",
  "wbm_022": "iOS .p8 key",
  "wbm_023": "iOS package name",
  "wbm_024": "iOS package name",
  "wbm_025": "iOS provisioning profile",
  "wbm_026": "iOS provisioning profile pending upload",
  "wbm_027": "iOS test build",
  "wbm_028": "iOS signing materials missing: .p12 certificate / provisioning profile / certificate password incomplete",
  "wbm_029": "iOS certificate password iosCerPwd",
  "wbm_030": "iOS certificate (.p12) pending upload",
  "wbm_031": "oem_config.json field; apply via the platform",
  "wbm_032": "Required in oem_config.json",
  "wbm_033": "Required in oem_config.json (a separate password from the Keystore password)",
  "wbm_034": " · pending finalization",
  "wbm_035": "— (the sync entry of the former \"Data\" page was removed with the built-in mock data; pending real components)",
  "wbm_036": "— (pending real components)",
  "wbm_037": "\"Me\" page: About Us",
  "wbm_038": "\"Me\" page: Feedback",
  "wbm_039": "\"Me\" page: Terms of Service",
  "wbm_040": "\"Me\" page: Privacy Policy",
  "wbm_041": "\"Device\" page: device information",
  "wbm_042": "\" is a Java reserved word and cannot be used in the package name",
  "wbm_043": "\" is a reserved scheme; please change it",
  "wbm_044": "Upload build artifacts",
  "wbm_045": "Available countries / regions",
  "wbm_046": "Store listing configuration",
  "wbm_047": "Differs from the Android package name; keep both platforms consistent",
  "wbm_048": "Profile - dark",
  "wbm_049": "Profile - light",
  "wbm_050": "Profile & settings",
  "wbm_051": "Profile (dark) @2x",
  "wbm_052": "Profile (light) @2x",
  "wbm_053": " characters",
  "wbm_054": " characters, exceeding the suggested ",
  "wbm_055": " components",
  "wbm_056": " pages · enabled ",
  "wbm_057": "Mainland China",
  "wbm_058": "Chinese",
  "wbm_059": "Chinese name",
  "wbm_060": "Theme color A",
  "wbm_061": "For test distribution only; valid for 30 days",
  "wbm_062": "Weight management",
  "wbm_063": "Weight Trend",
  "wbm_064": "Trial",
  "wbm_065": "Keep: ",
  "wbm_066": "Health & Fitness",
  "wbm_067": "Health & Fitness",
  "wbm_068": "Company introduction",
  "wbm_069": "Company name",
  "wbm_070": "About page copy",
  "wbm_071": "Built-in sample data (first visit)",
  "wbm_072": "Determines the artifact format: mainland APK / Google Play AAB",
  "wbm_073": "Prepare build environment",
  "wbm_074": "Upload in \"2-B Splash Screens\" and retry",
  "wbm_075": "Feature configuration",
  "wbm_076": "Package names may only use lowercase letters",
  "wbm_077": "QR codes for package printing",
  "wbm_078": "Medical",
  "wbm_079": "Kilogram (kg)",
  "wbm_080": "Kilogram kg",
  "wbm_081": "Units & language",
  "wbm_082": "Placeholder components",
  "wbm_083": "Centimeter (cm)",
  "wbm_084": "Centimeter cm",
  "wbm_085": "Umeng Analytics",
  "wbm_086": "Feedback email",
  "wbm_087": "Only lowercase letters, digits and the symbols - + . are allowed",
  "wbm_088": "Submittable to app stores; permanently valid",
  "wbm_089": "Optional (some store scenarios)",
  "wbm_090": "Sync health data to Apple Health",
  "wbm_091": "Sync health data to Health Connect",
  "wbm_092": "No",
  "wbm_093": "Includes localized push / analytics services",
  "wbm_094": "Splash images (8: background / logo / bottom / device frame × @2x@3x)",
  "wbm_095": "Launch screen preview",
  "wbm_096": "Splash logo",
  "wbm_097": "Splash logo @2x",
  "wbm_098": "Splash logo @3x",
  "wbm_099": "Splash bottom",
  "wbm_100": "Splash bottom @2x",
  "wbm_101": "Splash bottom @3x",
  "wbm_102": "Splash device frame / shell base image; platform placeholders available (names follow the packager contract)",
  "wbm_103": "Splash device frame",
  "wbm_104": "Splash device frame @2x",
  "wbm_105": "Splash device frame @3x",
  "wbm_106": "Splash background",
  "wbm_107": "Splash background @2x",
  "wbm_108": "Splash background @3x",
  "wbm_109": "Brand logo",
  "wbm_110": "Brand name",
  "wbm_111": "Identifier used to launch the app (Deep Link); written to the scheme in oem_config.json",
  "wbm_112": "Store category",
  "wbm_113": "Store links (permanent QR codes)",
  "wbm_114": "Domestic analytics SDK; recommended to keep for mainland builds",
  "wbm_115": "Region",
  "wbm_116": "Invalid region value: ",
  "wbm_117": "Basic information",
  "wbm_118": "Mainland version",
  "wbm_119": "Weather / workout routes",
  "wbm_120": " characters; easily truncated under the home-screen icon",
  "wbm_121": " characters, exceeding the suggested ",
  "wbm_122": "Official site / domestic app stores",
  "wbm_123": "Location SDK",
  "wbm_124": "The computing library secret has not been requested from the platform by email yet; it must be completed before packaging",
  "wbm_125": "Centered brand logo",
  "wbm_126": "Tools",
  "wbm_127": "Uploaded",
  "wbm_128": "Issued",
  "wbm_129": "distributed",
  "wbm_130": "Applied",
  "wbm_131": "Catty (jin)",
  "wbm_132": "Tools",
  "wbm_133": "Ads SDK",
  "wbm_134": "App name",
  "wbm_135": "App name is limited to ",
  "wbm_136": "App icon",
  "wbm_137": "App icon pending upload (1024×1024 PNG)",
  "wbm_138": "App description",
  "wbm_139": "App type",
  "wbm_140": "Bottom copyright / slogan area",
  "wbm_141": "Lowercase letters recommended for all segments (e.g. ",
  "wbm_142": "Splash / rewarded ads",
  "wbm_143": " images",
  "wbm_144": ")",
  "wbm_145": "Not applied",
  "wbm_146": "Required resource missing: PIC_Launch_Image (splash background)",
  "wbm_147": "Must start with a lowercase letter",
  "wbm_148": "Me",
  "wbm_149": "Watch extension (iOS only)",
  "wbm_150": "Package app resources",
  "wbm_151": "Required for packaging · apply by email · has an expiry date",
  "wbm_152": "Custom devices configured in the backend",
  "wbm_153": "Submit for store review",
  "wbm_154": "Search keywords",
  "wbm_155": "Supported units · weight unitList",
  "wbm_156": "Supported units · length lengthList",
  "wbm_157": "Supported languages languageList (30)",
  "wbm_158": "Supported device models",
  "wbm_159": "Support website",
  "wbm_160": "Data",
  "wbm_161": "Data trend charts and analysis",
  "wbm_162": "Array",
  "wbm_163": "Array; for store search optimization",
  "wbm_164": "Full-screen background image; must not cover the splash logo when overlaid",
  "wbm_165": "Jin",
  "wbm_166": "日本語",
  "wbm_167": "Yes",
  "wbm_168": "Smart scale",
  "wbm_169": "Dark Professional",
  "wbm_170": "Not uploaded",
  "wbm_171": "Unchecked modules are removed by the packager",
  "wbm_172": "Local draft (localStorage simulated server)",
  "wbm_173": "Build management",
  "wbm_174": "Validate configuration integrity",
  "wbm_175": "Format: com.company.product (at least two segments, each starting with a lowercase letter, containing only lowercase letters / digits / underscores)",
  "wbm_176": "Module trimming (kept items)",
  "wbm_177": "Release builds require complete signing materials for both platforms. Complete them in \"7-B iOS Certificates\" and retry",
  "wbm_178": "Release",
  "wbm_179": "Segment \"",
  "wbm_180": "Vitality Cards",
  "wbm_181": "Test build distribution",
  "wbm_182": "Overseas",
  "wbm_183": "Required for overseas release",
  "wbm_184": "Overseas analytics / crash / push",
  "wbm_185": "Channel identifier / Scheme",
  "wbm_186": "Channel identifier Scheme",
  "wbm_187": "Version type",
  "wbm_188": "Invalid version type value: ",
  "wbm_189": "Wang Xiaoming",
  "wbm_190": "Terms of Service URL",
  "wbm_191": "Terms of Service (Chinese)",
  "wbm_192": "Terms of Service (English)",
  "wbm_193": "Request email sent; waiting for the platform to issue it (usually 1-2 business days)",
  "wbm_194": "UI configuration",
  "wbm_195": "Login background",
  "wbm_196": "Login background @2x",
  "wbm_197": "Login background @3x",
  "wbm_198": "Target channels (mainland / Google Play)",
  "wbm_199": "Pound (lb)",
  "wbm_200": "Pound lb",
  "wbm_201": " types: ",
  "wbm_202": "Sign and generate QR code",
  "wbm_203": "简体中文",
  "wbm_204": "Simple & Fresh",
  "wbm_205": "繁體中文",
  "wbm_206": "Classic Health",
  "wbm_207": "Dimension Data",
  "wbm_208": "Compile resources for both platforms",
  "wbm_209": "Contact person",
  "wbm_210": "Contact phone",
  "wbm_211": "Contact email",
  "wbm_212": "Inch (in)",
  "wbm_213": "Inch inch",
  "wbm_214": "English name",
  "wbm_215": "Stone st",
  "wbm_216": "Stone+pound st:lb",
  "wbm_217": "Pgyer beta distribution",
  "wbm_218": "Computing library secret (oem_config.json → calculate)",
  "wbm_219": "Device",
  "wbm_220": "Device management & connection",
  "wbm_221": "Device config file",
  "wbm_222": "This package name is taken; please change it",
  "wbm_223": "Please fill in",
  "wbm_224": "Please fill in the app name",
  "wbm_225": "Please fill in the channel identifier / scheme",
  "wbm_226": "Please select a region",
  "wbm_227": "Please select a version type",
  "wbm_228": "Trends",
  "wbm_229": "Trends page",
  "wbm_230": "Body Data",
  "wbm_231": "Body data details and records",
  "wbm_232": "Sports & Fitness",
  "wbm_233": "Weight curve of the last 30 days · sample component (src/components/workbench-preview/)",
  "wbm_234": "Length must be ",
  "wbm_235": "Privacy Policy URL",
  "wbm_236": "Privacy Policy (Chinese)",
  "wbm_237": "Privacy Policy (English)",
  "wbm_238": "For the Google Play Store",
  "wbm_239": "In-page components (5 pages)",
  "wbm_240": "Page template",
  "wbm_241": "Page backgrounds (@2x/@3x each)",
  "wbm_242": " complete (images ",
  "wbm_243": " items (enabled ",
  "wbm_244": "Preview brand row / launch screen",
  "wbm_245": "Preview icon gradient / launch screen background; written to oem_config.json → colors.light/dark.brand_100 (opaque ARGB)",
  "wbm_246": "Preview avatar / launch screen icon",
  "wbm_247": "Preview layout / dark mode",
  "wbm_248": "Preview bottom navigation (including order)",
  "wbm_249": "Preview title / launch screen",
  "wbm_250": "Preview background badge",
  "wbm_251": "Preview greeting language / \"Me\" page default language",
  "wbm_252": "Diet Data",
  "wbm_253": "Home",
  "wbm_254": "Component lists of the Home / Trends / Data pages (including order)",
  "wbm_255": "Home header - dark",
  "wbm_256": "Home header - light",
  "wbm_257": "Home header (dark) @2x",
  "wbm_258": "Home header (dark) @3x",
  "wbm_259": "Home header (light) @2x",
  "wbm_260": "Home header (light) @3x",
  "wbm_261": "Advanced features",
  "wbm_262": "Simplified Chinese / metric by default; localized services",
  "wbm_263": "English / imperial by default; Google services",
  "wbm_264": "Default language defaultLanguage",
  "wbm_265": "Default weight unit defaultUnit",
  "wbm_266": "Default length unit defaultLength",
  "wbm_267": "(all trimmed)",
  "wbm_268": "(no components available)",
  "wbm_269": "(not enabled)",
  "wbm_270": "(off)",
  "wbm_271": "(no store link bound)",
  "wbm_272": "(no channel selected)",
  "wbm_273": "(no device models configured)",
  "wbm_274": "(empty)",
  "wbm_275": "; differs from the Android package name; keep both platforms consistent",

  // ===== Homepage module docs (English titles & links) =====
  "en_mini_guide": "Mini Program Plugin - Prerequisites and Integration Guide",
  "en_mini_faq": "Mini Program Plugin - FAQ",
  "en_mini_device_access": "Mini Program Plugin Device Integration",
  "en_mini_release_notes": "Mini Program Plugin Release Notes",
  "en_android_guide": "Android SDK - Prerequisites & Integration Guide",
  "en_android_faq": "Android SDK - FAQ",
  "en_android_device_access": "Android SDK - Device Integration",
  "en_android_release_notes": "Android BluetoothKit Demo Release Notes",
  "en_ios_guide": "iOS SDK - Prerequisites & Integration Guide",
  "en_ios_faq": "iOS SDK - FAQ",
  "en_ios_device_access": "iOS SDK - Device Integration",
  "en_ios_release_notes": "iOS SDK Release Notes",
  "en_cloud_guide": "Cloud Calculation Library Prerequisites & Integration Guide",
  "en_cloud_faq": "Cloud Calculation Library - FAQ",
  "en_cloud_api_reference": "Cloud Calculation Library - API Reference",
  "en_cloud_release_notes": "Cloud Calculation Library Release Notes",
  "en_open_platform_faq": "Open Platform FAQ",
  "en_open_platform_best_practice": "Open Platform Registration & Configuration Best Practices",
  "en_wifi_quick_start": "WiFi/4G Scale Server - Quick Start",
  "en_wifi_release_notes": "WiFi/4G Scale Server API Release Notes",
  "en_wifi_faq": "WiFi/4G Scale Server API - FAQ",
  "en_wifi_api_implementation": "WiFi/4G Scale Server - API Implementation",
  "en_flutter_guide": "Flutter SDK - Prerequisites & Integration Guide",
  "en_flutter_faq": "Flutter SDK - FAQ",
  "en_flutter_device_access": "Flutter SDK - Device Integration",
  "en_flutter_release_notes": "Flutter SDK Release Notes",
  "en_harmony_guide": "HarmonyOS SDK - Prerequisites and Integration Guide",
  "en_harmony_faq": "HarmonyOS SDK - FAQ",
  "en_harmony_device_access": "HarmonyOS SDK - Device Integration",
  "en_harmony_release_notes": "HarmonyOS SDK Release Notes",

  // ===== Doc Center (DocCenter) =====
  "doc_overview": "Overview",
  "doc_overview_guide": "Integration Overview",
  "doc_overview_guide_desc": "New here? Start with the overall integration flow and a comparison of all integration options.",
  "doc_best_practice_guide": "Open Platform Registration & Configuration Best Practices",
  "doc_best_practice_desc": "Recommended first read: practices and tips for platform registration and configuration.",
  "doc_group_main": "Development",
  "doc_group_support": "Support",
  "doc_count_unit": " docs",
  "doc_overview_desc": "This page collects all related docs for this integration: guide, device integration, API reference, FAQ and release notes. Start with the integration guide, and refer to the FAQ or release notes when you run into issues.",
  "doc_start_guide": "Get Started",
  "doc_open_new_page": "Open in new page",
  "doc_view_tip": "Chrome is recommended. If the doc asks for Feishu login, please open it in a new page.",
  "doc_loading": "Loading document…",
  "doc_not_found": "Document not found. Please select from the left menu.",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en_US.js